import { render, staticRenderFns } from "./main_streaming.vue?vue&type=template&id=814b416a&scoped=true"
import script from "./main_streaming.vue?vue&type=script&lang=js"
export * from "./main_streaming.vue?vue&type=script&lang=js"
import style0 from "./main_streaming.vue?vue&type=style&index=0&id=814b416a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814b416a",
  null
  
)

export default component.exports